import { render, staticRenderFns } from "./PosHistoryImportDetail.vue?vue&type=template&id=625bd1ff&scoped=true&"
import script from "./PosHistoryImportDetail.vue?vue&type=script&lang=js&"
export * from "./PosHistoryImportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625bd1ff",
  null
  
)

export default component.exports